import $ from 'jquery';
import 'jquery-validation';
import 'jquery-validation/dist/localization/messages_ru';
import datepickerFactory from 'jquery-datepicker';
import datepickerRUFactory from 'jquery-datepicker/i18n/jquery.ui.datepicker-ru';

datepickerFactory($);
datepickerRUFactory($);

import {goAjaxForm} from '../common/ajax-form';

const form = ($form) => {
    if ($form.length) {
        goAjaxForm({
            $form: $form,
            onSuccess: data => window.location.href = data.success_url,
            scroll: false,
            show_msg_ok: false,
            warning: true,
        });
    }
};

$(function () {
    const $form = $('#id_statement_form');
    if ($form.length) {
        $form.validate();
        form($form);
    }

    $('.datepicker').datepicker();
    $.datepicker.regional['ru'];
});




// WEBPACK FOOTER //
// ./js/statement/form.js